import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { AddSmartSearchDialogFormPropertySelection } from '@platform/smart-search/utils/formUtils';
import { PropertyMortgageSelectComponent } from '@shared-lib/components/form-components/property-mortgage-select/property-mortgage-select.component';
import { PropertyMortgageSelectItem } from '@shared-lib/models/property-mortgage-select-item.model';
import { InlineRedirectLinkComponent } from '@shared/components/inline-redirect-link/inline-redirect-link.component';
import { StepperComponent } from '@shared/components/stepper/stepper.component';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'cp-add-smart-search-property-selection',
  imports: [StepperComponent, PropertyMortgageSelectComponent, ReactiveFormsModule, SkeletonModule, InlineRedirectLinkComponent],
  templateUrl: './add-smart-search-property-selection.component.html',
  styleUrls: ['./add-smart-search-property-selection.component.scss', '../add-smart-search-dialog-step.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddSmartSearchPropertySelectionComponent implements OnInit {
  @Input({ required: true }) formGroupName: string;
  @Input() headline = 'Create new search for property';
  @Input({ required: true }) propertyWithMortgageSelectItems: PropertyMortgageSelectItem[];
  @Input({ required: true }) isLoadingPlatformItems = true;
  @Input({ required: true }) isSkipPropertySelectPossible = false;
  @Input() isBackButtonVisible = true;
  @Output() nextClicked = new EventEmitter();
  @Output() backClicked = new EventEmitter();

  private readonly rootFormGroup = inject(FormGroupDirective);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly destroyRef = inject(DestroyRef);

  protected stepFormGroup: FormGroup<AddSmartSearchDialogFormPropertySelection>;

  @ViewChild('propertyMortgageSelect') propertyMortgageSelect: PropertyMortgageSelectComponent;

  ngOnInit(): void {
    this.stepFormGroup = this.rootFormGroup.control.get(this.formGroupName) as FormGroup<AddSmartSearchDialogFormPropertySelection>;
    this.stepFormGroup.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.changeDetectorRef.detectChanges());
  }

  emitNextClicked(): void {
    if (this.stepFormGroup.valid) {
      this.nextClicked.emit();
    }
  }

  emitBackClicked(): void {
    this.backClicked.emit();
  }

  skipPropertySelection(): void {
    this.stepFormGroup.patchValue({ propertyMortgageSelectItem: null });
    this.nextClicked.emit();
  }
}
